export const RECEIVED_SERVICE = 'RECEIVED_SERVICE'
export const RECEIVED_CURRENT_TICKETS = 'RECEIVED_CURRENT_TICKETS'
export const RECEIVED_CURRENT_TICKET = 'RECEIVED_CURRENT_TICKET'
export const RECEIVED_WORKER = 'RECEIVED_WORKER'
export const RECEIVED_WORKERS = 'RECEIVED_WORKERS'
export const RECEIVED_LOGGED_USER = 'RECEIVED_LOGGED_USER'
export const RECEIVED_DEVICES = 'RECEIVED_DEVICES'
export const RECEIVED_NEXT_TICKET = 'RECEIVED_NEXT_TICKET'
export const RECEIVED_NEXT_TICKETS = 'RECEIVED_NEXT_TICKETS'
export const RECEIVED_TICKETS_WAITING_COUNT = 'RECEIVED_TICKETS_WAITING_COUNT'
export const RECEIVED_QUEUE_UPDATE = 'RECEIVED_QUEUE_UPDATE'
export const RECEIVED_NEWS = 'RECEIVED_NEWS'
export const RECEIVED_NOTIFIERS = 'RECEIVED_NOTIFIERS'
export const RECEIVED_SERVICES = 'RECEIVED_SERVICES'
export const RECEIVED_USERS = 'RECEIVED_USERS'
export const RECEIVED_OPERATORS = 'RECEIVED_OPERATORS'
export const DELETE_SERVICE = 'DELETE_SERVICE'
export const RECEIVED_FENIX_USER = 'RECEIVED_FENIX_USER'
export const CLEAR_FENIX_USER = 'CLEAR_FENIX_USER'
export const SET_CURRENT_TICKET = 'SET_CURRENT_TICKET'

export const CLEAR_SERVICE_CONTEXT = 'CLEAR_SERVICE_CONTEXT'
